import 'slick-carousel/slick/slick'

export default class PostsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-posts-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {

            // Loop through each slider and initialize slick individually to avoid conflicts if multiple sliders are on the same page.
            this.settings.$slider.each((index, element) => {
                const $slider = $(element);
                const sliderId = $slider.data('slider-id');

                $slider.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: false,
                    prevArrow: $(`.js-posts-slider-previous[data-slider-id="${sliderId}"]`),
                    nextArrow: $(`.js-posts-slider-next[data-slider-id="${sliderId}"]`),

                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                dots: false,
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                dots: false,
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                dots: false,
                                slidesToShow: 3,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                dots: false,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            },
                        },
                    ]
                });
            });
        }

    }

};

new PostsSlider();